import Tooltip from '@components/shared/tooltip/Tooltip';
import { Icon, Typography } from '@components/style';
import { theme } from '@styles/theme';
import { FC } from 'react';

type InsightsIconProps = {
  toolTipText: JSX.Element;
  color?: string;
  type: string;
  size: number;
  additionalCssClass?: string;
  dataTestId?: string;
};

const InsightsIcon: FC<InsightsIconProps> = ({
  dataTestId,
  toolTipText,
  color,
  type,
  size,
  additionalCssClass,
}) => {
  const getTrigger = (): JSX.Element => {
    return (
      <Icon
        data-testid={dataTestId || 'insights-icon'}
        type={type}
        size={size}
        color={color ?? theme.palette.text.purple}
      />
    );
  };

  const getContent = (): JSX.Element => {
    return toolTipText ? (
      <Typography size={theme.typography.h5} color={theme.palette.lightGray}>
        {toolTipText}
      </Typography>
    ) : null;
  };

  return (
    <Tooltip
      trigger={getTrigger()}
      content={getContent()}
      cssClass={`portfolio-tooltip ${additionalCssClass}`}
    />
  );
};

export default InsightsIcon;
